<app-edit-account [availableRegions]="availableRegions"></app-edit-account>
<!-- WHEN THE SYSADMIN WORKS WITH OTHER LANGUAGES, JUST UNCOMMENT BELOW AND REMOVE THE LINE ABOVE-->
<!-- <div class="account-settings-root" *transloco="let t">
  <mat-tab-group dynamicHeight>
    <mat-tab tab [label]="t('account')">
      <ng-template mat-tab-label>
        <div class="tab-label">
          <mat-icon class="material-icons-outlined">account_circle</mat-icon>
          <span>{{ t('account') }}</span>
        </div>
      </ng-template>
      <app-edit-account [availableRegions]="availableRegions"></app-edit-account>
    </mat-tab>
    <mat-tab tab [label]="t('settings')">
      <ng-template mat-tab-label>
        <div class="tab-label">
          <mat-icon class="material-icons">settings</mat-icon>
          <span>{{ t('settings') }}</span>
        </div>
      </ng-template>
      <app-edit-settings></app-edit-settings>
    </mat-tab>
  </mat-tab-group>
</div> -->
